$(document).ready(function() {
  $(document).on('keypress', '.commissions-edit-component .edit-commission-field-js', function(e) {
    // When enter is pressed on an input field, update all commissions
    if (e.which === 13) updateCommissions($(this).closest('.component'));
  });

  $(document).on('click', '.commissions-edit-component .save-commissions-js', function(e) {
    // When the update button is clicked, update all commissions
    updateCommissions($(this).closest('.component'));
  });

  $(document).on('click', '.commissions-edit-component .add-new-commission-btn-js', function(e) {
    // When new commission line button clicked, add new empty row to the table
    const component = $(this).closest('.component');
    const tableBody = component.find('table tbody');
    const commissionPeriodId = $(this).attr('commission_period_id');
    const hsDealId = $(this).attr('deal_id');
    const commissionType = $(this).attr('commission_type');

    $.post('/components/commissions/edit/new_line', { commission_period_id: commissionPeriodId, hs_deal_id: hsDealId, commission_type: commissionType }).done(function(response) {
      // Expecting html, but if JSON returns there is an error
      if (response.success === false) {
        alert(`Could not add new commission line: ${response.error}`);
      } else {
        reloadComponent(component);
      }
    });
  })

  $(document).on('click', '.commissions-edit-component .remove-commission-btn-js', function(e) {
    // When remove commission is button clicked, remove the row from the table
    const component = $(this).closest('.component');
    const parentRow = $(this).closest('tr');
    const commissionId = parentRow.attr('id');

    $.post('/components/commissions/edit/remove_line', { commission_id: commissionId }).done(function(response) {
      if (response.success) {
        parentRow.remove();
        reloadComponent(component);
      } else {
        alert(response.error);
      }
    });
  })

  function updateCommissions(component) {
    const trs = component.find('table tbody tr');
    const commissions = {};
    trs.each(function(i, tr) {
      tr = $(tr);
      const commissionId = tr.attr('id');
      const rate = tr.find('input[name="rate"]').val();
      const totalAmount = tr.find('input[name="total_amount"]').val();
      const label = tr.find('input[name="label"]').val();
      const payeeId = tr.find('select[name="payee_id"]').val();
      commissions[commissionId] = { rate: rate, total_amount: totalAmount, label: label, payee_id: payeeId };
    });

    $.post('/components/commissions/edit', { commissions: commissions }).done(function(response) {
      if (response.success) {
        reloadComponent(component);
      } else {
        alert(response.error);
      }
    });
  }
});
